import React from 'react'
import UserMenusContainer from '../../containers/usermenumng/UserMenusContainer'


const UserMenuViewPage = () => {
  return (
    <UserMenusContainer/>
  )
}

export default UserMenuViewPage